import { IContextMunicipality } from "./../types/municipality.interface";
import { createContext } from "react";

const MunicipalityScreen = createContext<IContextMunicipality>({});

export default MunicipalityScreen;
